import { useCallback } from 'react';
import { paymentOrdersService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { PaymentOrder } from '../types';

export function usePaymentOrders(
  options?: ResourceQueryOptions
): ResourceState<PaymentOrder> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      paymentOrdersService.getAll(opts) as unknown as Promise<{ data: PaymentOrder[]; meta?: any }>,
    []
  );
  return useResourceCollection<PaymentOrder>(fetchFn, options);
}

export function usePaymentOrder(
  id: string | null,
  options?: ResourceQueryOptions
): SingleResourceState<PaymentOrder> {
  const resourceId = id;
  const fetchFn = useCallback(
    (paymentOrderId: string | number, opts?: ResourceQueryOptions) =>
      paymentOrdersService.getById(paymentOrderId, opts) as unknown as Promise<PaymentOrder>,
    []
  );
  return useResourceById<PaymentOrder>(fetchFn, resourceId, options);
}

export function useCreatePaymentOrder(
  onSuccess?: (data: PaymentOrder) => void
): MutationState<PaymentOrder> {
  const createFn = useCallback(
    (data: any) => paymentOrdersService.create(data) as unknown as Promise<PaymentOrder>,
    []
  );
  return useCreateResource<PaymentOrder>(createFn, onSuccess);
}

export function useUpdatePaymentOrder(
  onSuccess?: (data: PaymentOrder) => void
): MutationState<PaymentOrder> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      return paymentOrdersService.update(id, data) as unknown as Promise<PaymentOrder>;
    },
    []
  );
  return useUpdateResource<PaymentOrder>(updateFn, onSuccess);
}

/**
 * Delete payment order using documentId
 * @param data - Full payment order object containing documentId
 */
export function useDeletePaymentOrder(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return paymentOrdersService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}

